import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { SowListComponent } from './sow-list.component';

const routes: Routes = [{ path: '', component: SowListComponent }];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class SowListRoutingModule {}
